import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { SearchAppState, Sort } from '../search-model';
import { completeUpdate, sortList } from '../search-slice';
import { sortButtonStyles } from '../../global/constants/theme/styles/tables/sort-button';


interface SortProps {
    name: string,
    label: string;
}

export const SortButton = (props: SortProps) => {
    const classes = sortButtonStyles();
    const [descending, setDescending] = useState(false);
    const dispatch = useDispatch();
    const sortBy = useSelector<SearchAppState, Sort>(a => a.searchState.sortBy);
    const handleChange = () => {
        setDescending(!descending);
        const sort: Sort = {
            prop: props.name,
            descending: !descending,
        };
        dispatch(sortList(sort));
        dispatch(completeUpdate());
    };

    return (
        <button className={`un-button input-label ${classes.sortButton} ${sortBy && sortBy.prop === props.name && sortBy?.descending ? 'active' : ''} `} type='button' onClick={handleChange} ><span>{props.label} <ArrowDropDownIcon /></span></button>
    );

};